

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import Button from "../../shared/Button"
import PageTopTitle from "../../shared/PageTopTitle"
import { adminUyeSurucuEkle } from "../../../features/admin2/admin2Slice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 800px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const AdminAddUyeSurucuModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const { uyeItemData, isLoadingAdminUyeSurucuEkle} = useSelector(state => state.admin2)

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [phoneNumber, setPhoneNumber] = useState("")

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        if(phoneNumber){
            dispatch(adminUyeSurucuEkle({masterIdPhoneNumber: uyeItemData.phoneNumber, SlaveIdPhoneNumber: phoneNumber}))
        }
    }
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Sürücü Ekle"}/>
        <div className="content">
            <InputText data={phoneNumber} setData={(e) => setPhoneNumber(e.target.value)} labelText="Cep Telefonu" name={"phoneNumber"} inputWidth={"370px"}/>
        </div>

        <div className="button-grp">
            <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingAdminUyeSurucuEkle ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Ekle"}</Btn>
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AdminAddUyeSurucuModal